module.exports = __webpack_public_path__ + "static/media/fake_sales_report.826e5d58.png";